import React from 'react'
import { ToastContainer } from 'react-toastify'
import {
  CloseButton as CloseButtonToast,
  CloseButton,
} from './components/Toasts'
import CriticalErrorModal from './containers/CriticalErrorModal'
import { I18n } from './i18n'
import Routes from './routes'
import {
  BrowserStyles,
  DateStyles,
  GlobalStyles,
  theme,
  ThemeProvider,
} from './theme'
import { LimitModal } from './containers/PremiumLimitModal'
import InfoModal from './containers/PremiumInfoModal'
import { is } from './components/MediaQuery'
import ModalContainer from './containers/Modals'
import NewVersionModal from './containers/NewVersionModal'
import OnboardingVideoModal from './containers/OnbordingModals/OnboardingVideoModal'
import SurveyModal from './containers/OnbordingModals/SurveyModal'

const App = () => {
  const isDesktop = is.desktop()

  // ;(window as any).UA.then(function(sdk) {
  //   sdk.create().then(function(result) {
  //     console.log('Channel ID: %s', result.channelId)
  //   })
  //   sdk.register()
  // })

  return (
    <I18n.I18nextProvider i18n={I18n.i18n}>
      <ThemeProvider theme={theme}>
        <React.Fragment>
          <BrowserStyles />
          <GlobalStyles />
          <DateStyles />

          <ToastContainer
            autoClose={5000}
            hideProgressBar={true}
            style={{
              alignItems: 'flex-end',
              display: 'flex',
              flexDirection: 'column',
              width: 'auto',
            }}
            enableMultiContainer={true}
            containerId={'Main'}
            closeButton={<CloseButton />}
          />
          <ToastContainer
            autoClose={false}
            hideProgressBar={true}
            style={{
              alignItems: 'flex-end',
              display: 'flex',
              flexDirection: 'column',
              maxWidth: !isDesktop ? '100vw' : '90vw',
              right: !isDesktop ? '0vw' : 'calc(50vw - 575px)',
              top: !isDesktop ? '0vh' : '22vh',
              width: 'auto',
            }}
            enableMultiContainer={true}
            containerId={'Event'}
            closeButton={<CloseButtonToast />}
          />

          <ModalContainer />

          <LimitModal />
          <InfoModal />
          <NewVersionModal />
          <CriticalErrorModal />
          <OnboardingVideoModal />
          <SurveyModal />
          <Routes />
        </React.Fragment>
      </ThemeProvider>
    </I18n.I18nextProvider>
  )
}

export default App
